import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { disconnectWebsocket } from "../../../store/actions/websocketActions";
import { SalesUsers } from "../../admin/sales/SalesUsers";
import { Box, Container, Grid2 as Grid, CircularProgress } from "@mui/material";

const Sales = () => {
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const currentUser = useSelector((state) => state[currentSession].user);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [dataLoading, setDataLoading] = useState(true);
  const [salesData, setSalesData] = useState();

  const getDataRef = useRef();
  const dispatchCount = useRef(0);

  useEffect(() => {
    if (currentUser?.user) {
      if (currentUser?.user?.role !== "admin" || !currentUser?.user?.admin) {
        if (dispatchCount.current < 1) {
          dispatch(disconnectWebsocket(currentSession));
          navigate("/login");
          dispatchCount.current += 1;
        }
      }
    }
  }, [currentUser?.user, dispatch, currentSession, navigate]);

  useEffect(() => {
    const getData = async () => {
      try {
        const resp = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/nocApi/sales/users`,
          { currentSession: currentSession },
          { withCredentials: true }
        );

        setSalesData(resp.data.data);

        setDataLoading(false);
      } catch (e) {
        setDataLoading(false);
      }
    };

    if (
      !currentUser ||
      currentUser?.user?.role !== "admin" ||
      !currentUser?.user?.admin
    ) {
      return;
    } else {
      if (!getDataRef?.current) {
        getDataRef.current = true;
        getData();
      }
    }
  }, [currentSession, currentUser]);

  return (
    <>
      {dataLoading ? (
        <>
          <Box
            sx={{
              display: "flex",
              width: "100%",
              height: "100vh",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <CircularProgress color="warning" size="10rem" />
          </Box>
        </>
      ) : (
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            py: 3,
            backgroundColor: "#EEF2F6",
          }}
        >
          <Container maxWidth="xl" sx={{ mb: 4 }}>
            <Grid container spacing={5}>
              <Grid size={{ xs: 12, md: 12, lg: 12 }}>
                <SalesUsers
                  title="Sales Users"
                  staffRows={salesData?.users}
                  setSalesData={setSalesData}
                />
              </Grid>
            </Grid>
          </Container>
        </Box>
      )}
    </>
  );
};

export default Sales;
